import { useAttachmentImageGalleryActions } from './useAttachmentImageGalleryActions.js'
import { useAttachmentImageGalleryState } from './useAttachmentImageGalleryState.js'

export function useAttachmentImageGallery(props) {
  const state = useAttachmentImageGalleryState(props)
  const actions = useAttachmentImageGalleryActions({
    current: state.current,
    previewSrc: state.previewSrc,
    safeLen: state.safeLen,
    setActiveIndex: state.setActiveIndex,
    setZoom: state.setZoom,
  })
  return { ...state, ...actions }
}
